<template>
    <div class="container">
        <ModelConfig :secTitle="'Selecione a <b>Versão</b> do seu <b>' + this.resumeData.model + '</b>'"
        :showLeftCol="showCarLook" :showRigthCol="showCarOptions">
            <template v-slot:carLook>
                <Model :isMobile="isMobile" :detailsContent="detailsContent" :objImgs="defineDefault360ImgsArr" />
            </template>
            <template v-slot:carOptions>
                <p class="sidebarTitle"><b>Selecionar a {{ staticText.versionLabels[0] }}</b></p>
                <DetailsViewNav :isMobile="isMobile" :showContent="showCarOptions" @change-view="displayCarOptions">
                    <span><b>Selecionar {{ staticText.versionLabels[0] }}</b> ( {{ handleCarData.length }}  {{ staticText.versionLabels[1] }})</span>
                </DetailsViewNav>
                <FilterModel
                :campareLabel="staticText.versionLabels[1]"
                :itemsLenght="versionsLst(resumeData.modelid, resumeData.engineID).length"
                :transmission="setTransmissions"
                :selectedTransmission.sync="currTransmission"
                :prices.sync="currPrices"
                :rents.sync="currRents"
                :priceRange="handlePricesRanges" />
                <ListConfigCards :cardData="handleCarData" :isMotorCard="false" :selectedOption="defineDefaultversion"/>
            </template>
        </ModelConfig>
        <p v-show="showCarLook && isMobile" class="btn-secondary" @click="displayCarOptions">
            <span><b>Selecionar {{ staticText.versionLabels[0] }}</b> ({{ handleCarData.length }} {{ staticText.versionLabels[1] }})</span>
        </p>
        <div class="container-wrapContent">
            <FeaturedBlock :secTitle="dataBO.destaqueSect.destaqueTitle" :content="dataBO.destaqueSect.destaqueContent" />
            <Accordion :accordionObj="dataBO.faqs.faqsVersion" />
            <LegalMentions />
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapMutations, mapState } from 'vuex'
    import ModelConfig from '../components/TemplateParts/ModelConfig/ModelConfig.vue'
    import Model from '../components/TemplateParts/Model/Model.vue'
    import DetailsViewNav from '../components/TemplateParts/SimpleContent/DetailsViewNav.vue'
    import FilterModel from '../components/TemplateParts/FilterModel/FilterModel.vue'
    import ListConfigCards from '../components/TemplateParts/ListConfigCards/ListConfigCards.vue'
    import Accordion from '../components/TemplateParts/SimpleContent/Accordion.vue'
    import FeaturedBlock from '../components/TemplateParts/SimpleContent/FeaturedBlock.vue'
    import LegalMentions from '../components/TemplateParts/SimpleContent/LegalMentions.vue'
    import { comonFunctions } from '../mixins/comonFunctions'
    import { metatags } from '../mixins/comonMetaTags'
    import { mainFilterFunc } from '../mixins/filterFunctions'

    export default {
        name: 'Versions',
        components:{ ModelConfig, Model, DetailsViewNav, FilterModel, ListConfigCards, Accordion, FeaturedBlock, LegalMentions },
        mixins: [metatags, comonFunctions, mainFilterFunc ],
        data(){return{
            lenght: 2,
            seoData: {
                "title": "Configurador",
                'titleTemplate': 'Versões',
                "author": "Hyundai Portugal",
                "og_description": "Com o Configurador Hyundai, pode escolher e personalizar o seu Hyundai de sonho. Selecione o seu modelo favorito e escolha todas as características de acordo com as suas preferências.",
                "og_title": "Configurador Hyundai - Hyundai Portugal",
                "og_locale": "pt_PT",
                "og_type": "article",
                "og_site_name": "Hyundai Portugal"
            },
            currPage: 'Version',
        }},
        created(){
            // this.resumeData.newCfg && this.removeConfigKey('dsgExt')
        },
        provide:{
            page: 'Version',
        },
        beforeRouteLeave(to, prev, next){
            if(to.name == 'Motors'){
                next()
                return;
            }

            if(this.resumeData.isVersionSelected != true){
                alert('Selecione a versão!')
                return false
            }

            next()
        },
        computed:{
            ...mapState(['resumeData','versionsData']),
            ...mapGetters({
                detailsContent: 'resumeData/getModelDetailsContent',
                versionsLst: 'versionsData/getModelVersions',
                getVersionImg: 'images360/get360ImgByVersion',
            }),
            defineDefaultversion(){
                if(!this.resumeData.newCfg) return this.resumeData.versionID
                let routeParamVersion = this.$route.params?.versionCompared
                return (routeParamVersion != undefined) ? routeParamVersion : this.resumeData.versionID
            },
            handleCarData(){ //arr, bool transm or segm...
                let trmLgh = this.currTransmission.length;
                let priceLgh = this.currPrices.length;
                let rentLgh = this.currRents.length;
                let arrContent = this.versionsLst(this.resumeData.modelid, this.resumeData.engineID)

                if(trmLgh != 0){
                    let _content = this.filterByTransmission(arrContent)

                    if(priceLgh != 0){
                        let _array = this.filterByPrice(_content)
                        if(rentLgh != 0) return this.filterByRent(_array)
                        return _array
                    }

                    if(rentLgh != 0) return this.filterByRent(_content)
                    return _content
                }

                if(priceLgh != 0){
                    let _content = this.filterByPrice(arrContent)
                    if(rentLgh != 0) return this.filterByRent(_content)
                    return _content
                }

                if(rentLgh != 0) return this.filterByRent(arrContent)
                return arrContent
            },
            defineDefault360ImgsArr(){
                let imgs = this.getVersionImg(this.resumeData.modelid, this.resumeData.versionID)
                return imgs?.[0]?.externalColorImages360
            },
        },
        methods:{
            ...mapMutations({
                removeConfigKey: 'resumeData/REMOVE_CONFIGOPTIONS',
            }),
            getPageTitle(){
                return 'Selecione a <b>Versão</b> do seu' + this.resumeData.model;
            },
        },
    }
</script>
